import { defineMessages } from "react-intl";

export const changePasswordPageMessages = defineMessages({
  expiredMessage: {
    id: "change-password-page.expiredMessage",
    defaultMessage: "Ссылка на сброс пароля истекла",
  },
  expiredTitle: {
    id: "change-password-page.expiredTitle",
    defaultMessage: "Ошибка",
  },
  resend: {
    id: "change-password-page.resend",
    defaultMessage: "Запросить новую ссылку",
  },
  success: {
    id: "change-password-page.success",
    defaultMessage: "Пароль успешно изменен!",
  },
  title: {
    id: "change-password-page.title",
    defaultMessage: "Установите новый пароль",
  },
});

export const changePasswordFormMessages = defineMessages({
  continueButton: {
    id: "change-password.continueButton",
    defaultMessage: "Продолжить",
  },
  passwordLabel: {
    id: "change-password.password",
    defaultMessage: "Пароль",
  },
  passwordPlaceholder: {
    id: "change-password.password.placeholder",
    defaultMessage: "Ваш пароль",
  },
});
